import alt from 'components/Dispatcher';
import immutableStore from 'utils/immutableStore';
import CardReasonEditActions from 'actions/CardReasonEditActions';
import {Record} from 'immutable';
import CardReasonScheme from 'records/CardReasonScheme';
import {scorecardTypes} from 'records/Scorecard';
import ToastStore from '@store/toast/ToastStore';

@immutableStore
class CardReasonEditStore {
  constructor() {
    this.state = Record({
      initialCardReasonScheme: new CardReasonScheme(),
      cardReasonScheme: new CardReasonScheme(),
      wasErrorSaving: false,
      isSaving: false,
      saved: false,
      isLoading: false,
      schemeWithNameExists: false,
    })();
    this.bindActions(CardReasonEditActions);
    this.initNewFormForScoringScheme = this.initNewFormForScoringScheme.bind(this);
  }

  initializeForm() {
    this.setState({
      initialCardReasonScheme: new CardReasonScheme(),
      cardReasonScheme: new CardReasonScheme(),
      wasErrorSaving: false,
      isSaving: false,
      saved: false,
      schemeWithNameExists: false,
    });
  }

  initNewFormForScoringScheme(scoringScheme) {
    const entries = scorecardTypes[scoringScheme].answers.map(answer => ({
      point: answer.value,
    }));
    const cardReasonScheme = new CardReasonScheme({scoringScheme, entries});
    this.setState({
      initialCardReasonScheme: cardReasonScheme,
      cardReasonScheme,
      wasErrorSaving: false,
      isSaving: false,
      saved: false,
      schemeWithNameExists: false,
    });
  }

  // fetchCardReasonSchemeSuccess() {
  //   this.setState({isLoading: true, wasErrorFetching: false});
  // }

  fetchCardReasonSchemeSuccess(cardReasonScheme) {
    this.setState({
      isLoading: false,
      cardReasonScheme: cardReasonScheme,
      initialCardReasonScheme: cardReasonScheme,
    });
  }

  fetchScorecardError() {
    this.setState({isLoading: false, wasErrorFetching: true});
  }

  updateForm(cardReasonScheme) {
    this.setState({cardReasonScheme: cardReasonScheme});
  }

  saveCardReasonSchemeError(res) {
    if (res.response && res.response.status === 409) {
      this.setState({
        isLoading: false,
        schemeWithNameExists: true,
        saved: false,
      });
    } else {
      ToastStore.addToast({
        type: 'error',
        message: 'There was a problem saving the card reasons.',
      });
      this.setState({
        isLoading: false,
        schemeWithNameExists: false,
        saved: false,
      });
    }
  }

  saveCardReasonSchemeSuccess(res) {
    this.setState({isLoading: false, schemeWithNameExists: false, saved: true});
  }
}

export default alt.createStore(CardReasonEditStore);
